// The one place the Klydo API host is set, for every script in the theme.
// Swap the commented lines to point the storefront at a local API — and swap
// them back before committing, since the production line is what the live
// store has to load.
const API_BASE_URL = "https://api.klydoclock.com";
// const API_BASE_URL = "http://localhost:10010";
